import * as z from "zod";

export const completeMobileUpload = {
  name: "completeMobileUpload" as const,
  input: z.object({ token: z.string() }),
  output: z.object({ success: z.boolean() }),
};
